import React, { FC } from 'react';
import styled from 'styled-components';
import Box, { IBox } from 'Components/Grid/Box';
import { mediaMdDown, mediaSmDown } from 'theme/helpers/css';
import logo from './img/newLogo.svg';
import logoWithoutText from './img/logo.svg';
import globusLogo from './wl-img/globus.svg';
import { WLabel } from 'constants/enums';
import { selectByWL } from 'utils/wLabel';
import { BoxProps } from '@igooods/ui-kit';
import { addStyleIfPropTruly } from 'utils/styledComponents';
import { Transitions } from 'theme';
import { getIgorValue } from '../../../Modules/SearchAddress/selectors';
import { useSelector } from 'react-redux';
import igorImg from './img/igor.png';
import { useHistory } from 'react-router';

interface ILogoIcon extends IBox, Omit<BoxProps, 'theme'> {
  onClick?: () => void;
  className?: string;
}

const wlContainerDesktopStyles = selectByWL({
  [WLabel.Default]: 'max-width: 205px;',
  [WLabel.Globus]: 'width: 88px;',
});

const wlContainerTabletStyles = selectByWL({
  [WLabel.Globus]: 'width: 70px;',
});

const wlContainerMobileStyles = selectByWL({
  [WLabel.Globus]: 'width: 50px;',
});

const Container = styled(Box)`
  width: 100%;
  transition: ${Transitions.opacity};

  ${addStyleIfPropTruly(
    'onClick',
    `
    cursor: pointer;

    &:hover {
      filter: opacity(0.7);
    }`
  )}

  ${wlContainerDesktopStyles}

  ${mediaMdDown`
    ${wlContainerTabletStyles}
  `} 
  
  ${mediaSmDown`
    ${wlContainerMobileStyles}
  `} 
  
  img {
    width: 100%;
  }
`;

const LogoIcon: FC<ILogoIcon> = props => {
  const isIgor = useSelector(getIgorValue);
  const history = useHistory();

  const landings = [
    'dostavka',
    'rabota-v-igooods',
    'kak-eto-rabotaet',
    'akczii-i-skidki',
    'vybor-tovara-i-oplata',
    'obmen-i-vozvrat-tovara',
    'partnerstvo',
  ];

  const detectLandingPage = (landings: string[]): number => {
    const currentPage = landings.filter(landing => history.location.pathname.includes(landing));

    return currentPage.length;
  };

  const isLandingPage = Boolean(detectLandingPage(landings));

  const wlLogoImage = selectByWL({
    [WLabel.Globus]: <img src={globusLogo} alt="globus logo" />,
    [WLabel.Default]: <img src={isLandingPage ? logoWithoutText : logo} alt="igooods logo" />,
  });

  return isIgor ? (
    <Container {...props} mt={{ xs: 0.5 }}>
      <img src={igorImg} alt="igooods logo" />
    </Container>
  ) : (
    <Container {...props}>{wlLogoImage}</Container>
  );
};

export default LogoIcon;
